export const environment = {
  apiUrl: 'https://api.kvs.test.framna-par.cloud/',
  apiPrefix: '/api/web/v1',
  baseUrl: 'https://admin.kvs.test.framna-par.cloud',
  authRedirectPath: '/authorize',
  postLogoutPath: '',
  discoveryUrl: 'https://portaal.partou.nl/oauth2/v2/3e633606-345f-4d06-aff7-b8710006da38',
  helloIdClientId: '3e633606-345f-4d06-aff7-b8710006da38',
  version: 'test-1.0',
  useMocks: false,
  environmentLabel: 'TEST',
};
